/* eslint-disable react/prop-types */
// LanguageSelect.js

import { useState } from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import Select from "react-select";
import "./language.scss";
import ShortTextIcon from "@mui/icons-material/ShortText";
import LanguageIcon from "@mui/icons-material/Language";
import { HomeModel } from "../../../api/model/response/HomeModel";
import { LanguageModel } from "../../../api/model/response/LanguageModel";
import i18n from "../../../__product__/language/i18n";
import { getImage } from "../../../api/ApiPath";
import { useUserContext } from "../../../context/UserContext";

const LanguageSelect: React.FC<{
  currentLanguagesList: LanguageModel[];
  homeData: HomeModel;
}> = ({ currentLanguagesList, homeData }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { setSelectedLanguage } = useUserContext();

  const toggleLanguageMenu = () => {
    setIsOpen(!isOpen);
  };

  const changeLanguage = (selectedOption: string) => {
    setSelectedLanguage(selectedOption);
    void i18n.changeLanguage(selectedOption);
    setIsOpen(false); // Close the dropdown when an option is selected
    // You can add code here to update the language on your page
  };

  return (
    <div className={"languageSwitcher"}>
      <div className={"senorita-home-top-header"}>
        <ShortTextIcon fill={homeData?.titleColor ?? "#000"} />
        <div
          style={{
            backgroundColor: homeData?.iconColor
          }}
          className={"language-icon"}
          onClick={toggleLanguageMenu}
        >
          <LanguageIcon className={"icon"} />
        </div>
      </div>
      {isOpen && currentLanguagesList?.length > 1 && (
        <ul className={"languageList"}>
          {currentLanguagesList.map((language) => (
            <li
              key={language.language}
              onClick={() => changeLanguage(language.language)}
            >
              <img
                className={"language-icon2"}
                src={getImage(language.photoUrl || "")}
                alt={"language"}
              />{" "}
              <span>{language.description}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
export default LanguageSelect;
